<template>
	<div
		id="changepasswordModal"
		style="display: block"
		class="modal"
		role="dialog"
	>
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div>
						<h3 class="uptext">Change Password</h3>
					</div>
				</div>
				<div class="modal-body">
					<b-alert v-if="isChangePwdSuccess" variant="success" show
						>Password Successfully Changed.</b-alert
					>
					<b-alert v-if="errMsg" variant="danger" show>{{ errMsg }}</b-alert>
					<div class="formContent tableView">
						<!-- <div class="tableSection sectionEmail">
              <div class="block inputCell email isDisabled">
                <div class="title">Email</div>
                <div class="input placeholder">
                  <input
                    v-model="email"
                    type="email"
                    placeholder="hello@philipamour.com"
                    class="form-control"
                    disabled
                  />
                </div>
              </div>
            </div> -->

						<div class="tableSection sectionPassword">
							<!-- <div class="block inputCell newPassword">
                <div class="title">Confirm Code</div>
                <div class="input placeholder">
                  <input
                    v-model="code"
                    type="text"
                    name="code"
                    class="form-control password"
                  />
                </div>
              </div> -->

							<div class="block inputCell newPassword">
								<div class="title">New Password</div>
								<div class="input placeholder">
									<input
										v-model="newPassword"
										type="password"
										placeholder="New Password"
										name="newPassword"
										class="form-control password"
									/>
								</div>
							</div>

							<div
								class="block inputCell confirmPassword"
								:class="[!passwordError ? '' : 'errorField']"
							>
								<div class="title">Confirm Password</div>
								<div class="input placeholder">
									<input
										v-model="confirmPassword"
										type="password"
										placeholder="Confirm Password"
										name="confirmPassword"
										class="form-control password"
										v-on:keyup.enter="changePwd"
									/>
								</div>
							</div>

							<div class="error" v-if="passwordError">
								<div class="input placeholder">{{ errMsg }}</div>
							</div>
						</div>

						<!-- <div class="button buttonLarge" :class="[!(email && newPassword && confirmPassword) ? 'buttonDisabled':'buttonTint']">
                    <div class="title"  type="submit" @click="changePwd">Change Password</div>
                  </div> -->
					</div>
				</div>
				<div class="modal-footer">
					<div>
						<b-button class="btn-default btn-cancel" @click="$emit('close')"
							>Cancel</b-button
						>
						<b-button
							class="btn-default btn-submit"
							:disabled="!(newPassword && confirmPassword)"
							type="submit"
							@click="changePwd"
							>Done</b-button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getUserEmail } from "../utils/auth";
import Auth from "@aws-amplify/auth";
import Amplify from "@aws-amplify/core";

export default {
	name: "ChangePassword",
	props: ["oldPassword", "isChangePassword", "showing"],
	data() {
		return {
			fullPage: false,
			isLoading: false,
			email: getUserEmail(),
			code: "",
			newPassword: "",
			confirmPassword: "",
			dismissSecs: 5,
			dismissCountDown: 0,
			errMsg: "",
			passwordError: false,
			isChangePwdSuccess: false
		};
	},
	components: {
		Loading
	},
	mounted() {
		console.log(this.oldPassword);
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		changePwd() {
			this.errMsg = "";
			this.isLoading = true;
			Auth.currentAuthenticatedUser()
				.then(user => {
					return Auth.changePassword(user, this.oldPassword, this.newPassword);
				})
				.then(data => {
					if (data == "SUCCESS") {
						this.$emit("close");
						this.$emit("update:isChangePassword", false);
						this.$emit("update:showing", false);
					}
				})
				.catch(err => {
					this.isLoading = false;
					this.errMsg = err.message;
					this.dismissCountDown = this.dismissSecs;
				})
				.finally(() => {
					this.isLoading = false;
				});
			// Auth.forgotPasswordSubmit(this.email, this.code, this.newPassword)
			//   .then((data) => {
			//     this.isChangePwdSuccess = true;
			//     setTimeout(() => {
			//       this.$emit("close");
			//     }, 1000);
			//     // this.$router.push({ name: 'signin' , query : {email : this.email}})
			//   })
			//   .catch((err) => {
			//     this.isLoading = false;
			//     this.errMsg = err.message;

			//     this.dismissCountDown = this.dismissSecs;
			//   })
			//   .finally(() => {
			//     this.isLoading = false;
			//   });
		}
	}
};
</script>
